import { version } from '../module-version';
import { EnvironmentOptions } from '../types';

export const initEnvironmentDataTransformer = (options: EnvironmentOptions) => {
  return <TInput>(input: TInput): TInput => ({
    ...input,
    platform: { name: options.platform, version: options.platformVersion, variant: options.platformVariant },
    opco: options.opCo,
    environment: options.environment,
    trackerModuleVersion: version,
  });
};
